/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */
// import hooks
import useSWRMutation from "swr/mutation";
import client from "../../../feature-discovery/utils/axios.client.js";
/**
 * SWR hook usePostSDBProductTourUserDataHook
 */
export const usePostSDBProductTourUserDataHook = (axiosConfig, swrConfig) => useSWRMutation("usePostSDBProductTourUserDataHook", (_, { arg }) => client({
    url: `/user/tourdata`,
    data: "body" in arg ? arg.body : undefined,
    method: "post",
    params: {},
    ...axiosConfig,
}), swrConfig);
export default usePostSDBProductTourUserDataHook;
